module.exports = __webpack_public_path__ + "static/img/list__icon.62ced8ab.svg";